<template>
  <nav class="layout-footer footer bg-footer-theme">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
        <b-link :to="{ name: 'dashboard' }" class="footer-link">
          <span class="ic_container">
            <span class="ic ic-summary"></span>
          </span>
          <span class="txt">Dashboard</span>
        </b-link>
        <b-link :to="{ name: 'courses' }" class="footer-link">
          <span class="ic_container">
            <span class="ic ic-course"></span>
          </span>
          <span class="txt">Courses</span>
        </b-link>
        <!--
        <b-link class="footer-link">
          <span class="ic_container">
            <span class="ic ic-bullhorn"></span>
          </span>
          <span class="txt">Recommended</span>
        </b-link>
      -->
    </div>
  </nav>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'footerNavbar',
  props: ['active'],
  components: {
  },
  data: () => {
    return {
    }
  },

  mounted () {
  },

  methods: {
    navigateToTab (tab) {
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj
    }),
    isDegreeProgressActive () {
      if (this.active === 'degree') {
        return 'active'
      } else {
        return ''
      }
    },
    isCareerProgressActive () {
      if (this.active === 'career') {
        return 'active'
      } else {
        return ''
      }
    }
  },

  watch: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/app/misc/components/FooterNavbar.vue